<template>
  <modal
    name="modal--message"
    transition="nice-modal-fade"
    :click-to-close="true"
    :width="450"
    :height="'auto'"
    @before-open="beforeOpen"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4"
    >
      <div class="mb-8 text-center text-2xl font-normal">
        {{ message }}
      </div>
      <div class="flex justify-center">
        <div class="button" @click="closeModal">Close</div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'ModalMessage',
  data() {
    return {
      message: 'what'
    }
  },
  methods: {
    beforeOpen(event) {
      console.log('beforeOpen', event)
      this.message =
        event.params && event.params.message ? event.params.message : 'why'
    },
    closeModal() {
      this.$modal.hide('modal--message')
    }
  }
}
</script>
